export default (theme) => ({
  noMeetings: {
    fontSize: '20px',
    width: '100%',
    textAlign: 'center',
    marginTop: 60,
    marginBottom: 52
  },
  skeleton: {
    marginBottom: 10
  }
});
